import { useModuleConfigAttribute } from './useModuleConfigAttribute';

export const useNonAuthAccess = () =>
    useModuleConfigAttribute({
        attribute: 'nonAuthAccess',
        defaultValue: false,
    });
